import { Tr, Td, Badge } from '@chakra-ui/react'

export function ItemRow({ item, getStatusColor }) {
  return (
    <>
      <Tr>
        <Td color="white">{item.sequencia}</Td>
        <Td color="white">{item.codigo_produto}</Td>
        <Td color="white" maxWidth="300px" isTruncated>
          {item.descricao || item.descricao_produto}
        </Td>
        <Td color="white">{item.quantidade}</Td>
        <Td>
          <Badge colorScheme={getStatusColor(item.passo_atual)}>{item.passo_atual}</Badge>
        </Td>
        <Td>
          <Badge colorScheme={getStatusColor(item.proximo_passo)}>{item.proximo_passo}</Badge>
        </Td>
      </Tr>
    </>
  )
}
